import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import PersonOutline from '@material-ui/icons/PersonOutline';
import AgencyIcon from '@material-ui/icons/Store';
import CloseIcon from '@material-ui/icons/Close';
import styles from '../../pages/AgentSearch.scss';

FilterInput.propTypes = {
  active: PropTypes.string.isRequired,
  currentFilter: PropTypes.string.isRequired,
  returnFunc: PropTypes.func.isRequired,
};

function FilterInput(props) {
  const fiRoot = useRef(null);
  const {active} = props;
  const [displayMode, setDisplayMode] = useState(active);
  const [val, setVal] = useState(props.currentFilter);
  let startIcon = null;
  let placeholderText = '';
  let filterText = 'Filter';

  useEffect(() => {
    if (props.currentFilter != val) setVal(props.currentFilter)
  }, [props.currentFilter]);

  useEffect(() => {
    if (props.active != displayMode) {
      setDisplayMode(props.active);
    }
  }, [props.active]);

  if (active === 'agents') {
    placeholderText = 'Filter by Agent Name';
    filterText = 'Filter agents';
    startIcon = <PersonOutline className={styles.lightIcon} />;
  }
  else {
    placeholderText = 'Filter by Agency Name';
    filterText = 'Filter agencies';
    startIcon = <AgencyIcon className={styles.lightIcon} />;
  }

  const clearField = () => {
    if (fiRoot?.current?.value != '') {
      fiRoot.current.value = '';
      props.returnFunc('');
    }
  }

  const handleChange = (event) => {
    setVal(event.target.value);
    props.returnFunc(event.target.value);
  }

  return (
    <div>
      <TextField
        inputRef={fiRoot}
        size="small"
        fullWidth
        className={styles.filterInput}
        label={filterText}
        variant="outlined"
        placeholder={placeholderText}
        onChange={handleChange}
        value={val}
        InputProps={{
          startAdornment: startIcon,
          endAdornment: <IconButton onClick={clearField} size="small" aria-label="close icon"><CloseIcon className={styles.lightIcon} /></IconButton>
        }}
      />
    </div>
  )
}

export default FilterInput;
